<template>
    <ModalFormCard class="lg:min-w-[800px] modal-default" :action="action">
        <template #title>New subscription</template>

        <template #default="{ saving, errors }">
            <input type="hidden" name="user_id" :value="editingModel.user.id" />
            <input type="hidden" name="product_id" value="1" />

            <Select name="product_id" v-model:value='value.product_id' label="Product" :options="products" :disabled="saving" />

            <div class="grid lg:grid-cols-2 gap-4 grid-cols-1 mt-4" v-if='value.product_id == 1'>
                <Select
                    selectClass="!bg-grey text-15"
                    menuClass="!bg-grey"
                    name="industry_id"
                    label="Industry"
                    placeholder="Select your trade"
                    v-model:value="value.industry_id"
                    :options="industries"
                    :disabled="saving"
                    @update:value="getLocations"
                />

                <Select
                    selectClass="!bg-grey text-15"
                    menuClass="!bg-grey"
                    name="location_area_id"
                    label="Location"
                    placeholder="Select your next area"
                    v-model:value="value.location_area_id"
                    :options="locations"
                    :disabled="saving"
                    @update:value="
                        (id) => {
                            this.$refs.googleMap.setActiveArea(this.areas.find((a) => a.id == id))
                        }
                    "
                />
            </div>

            <div class="w-full bg-grey-400 mt-6" style="height: 308px" v-if='value.product_id == 1 && areas != null && areas.length > 0'>
                <GoogleMap
                    v-if="value.location_area_id != null && areas != null"
                    :areas="areas"
                    :area="parseInt(value.location_area_id)"
                    ref="googleMap"
                    @setArea="
                        (id) => {
                            value.location_area_id = id
                        }
                    "
                />
            </div>

            <Select
                selectClass="!bg-grey text-15"
                class="mt-4"
                menuClass="!bg-grey"
                name="plan_id"
                label="Plan"
                placeholder="Select a plan"
                v-model:value="value.plan_id"
                :options="planOptions"
                :disabled="saving"
                v-if="selected != false && selected.area && selected.area.available"
            />

            <div
                v-if="selected != false && selected.area && !selected.area.available"
                class="border-t border-b border-grey-500 h-[54px] flex items-center justify-between mt-8 select-none"
            >
                <p class="text-14" v-if="!isOnWaitingList">Notify me if this area becomes available</p>
                <p class="text-14" v-else>You are now on the waiting list</p>

                <Toggle :checked="isOnWaitingList" @toggle="toggleWaitingList" />
            </div>

            <template v-if="selected != false && selected.area && selected.area.available">
                <SubscriptionBreakdown class="mt-6" :productId="value.product_id" :plan="selected.plan" 
                    :industry="selected.industry" :area="selected.area" />

                <p class="font-semibold text-17 mt-6">Payment breakdown</p>

                <div class="flex items-center justify-between py-6 border-t border-grey-500 text-15 mt-6">
                    <p>{{ selected.plan.name }} subscription</p>
                    <p class="font-semibold">{{ $help.dp(selected.plan.monthly_cost) }}</p>
                </div>

                <div class="flex items-center justify-between py-6 border-t border-grey-500 text-15">
                    <p>VAT @ 20%</p>
                    <p class="font-semibold">{{ $help.dp((parseInt(selected.plan.monthly_cost) / 100) * 20) }}</p>
                </div>

                <div class="flex items-center justify-between py-6 border-y border-grey-500 text-15">
                    <p>Today's charge</p>
                    <p class="font-semibold">
                        {{ $help.dp(selected.plan.monthly_cost + (parseInt(selected.plan.monthly_cost) / 100) * 20) }}
                    </p>
                </div>

                <p class="text-15 font-semibold mt-6">
                    You are about to pay {{ $help.dp(selected.plan.monthly_cost, 0) }}+VAT to sign up for a
                    {{ selected.plan.name }} subscription
                </p>

                <p class="text-14 text-grey-900 mt-2">
                    Once you've paid for your subscription, it will be built and you will be launched. The day you launch will be your
                    billing date going forward. Your next payment of {{ $help.dp(selected.plan.monthly_cost, 0) }}+VAT will be taken on your
                    next billing date (One month after your subscription launches). Pay with an existing card, or add a new card to pay now
                </p>


                <SelectCard 
                    v-model:value="value.card_id"
                    :disabled="saving"
                    :options="cards"
                    valueKey="id"
                    class="mt-4"
                    :lastModal="{
                        view: 'SubscriptionCreate',
                        editingModel: this.editingModel,
                        options: { ...this.options, currentValue: this.value },
                    }"
                />
                <!-- <Select
                    selectClass="!bg-grey text-15"
                    class="mt-4"
                    menuClass="!bg-grey"
                    name="card_id"
                    label="Select card"
                    placeholder="Select a card"
                    v-model:value="value.card_id"
                    :disabled="saving"
                    :options="cards"
                    valueKey="id"
                    selectedCSS=""
                    @update:value="checkForAddNew"
                >
                    <template #label-right>
                        <button class="link-text text-purple-600 text-13" type="button" @click="addNew()">Add new card</button>
                    </template>

                    <template #option="{ option, selected }">
                        <div class="flex items-center w-full" v-if="option.html != 'Add new card'">
                            <PaymentMethodTable :paymentMethod="option" :table="false" />

                            <div class="flex items-center ml-4" v-if="option.default_payment_method != null && !selected">
                                <IconTrue class="stroke-white w-5 h-5 bg-black rounded-full" />

                                <p class="text-15 pl-2">Default</p>
                            </div>
                        </div>

                        <p v-else>{{ option.html }}</p>
                    </template>
                </Select> -->

                <template v-if='user.hasRole("zapo.super")'>
                    <InputCheckbox name="free_first_month" class="mt-4">
                        <p class="text-grey-900 text-14 pl-2">First month free</p>
                    </InputCheckbox>
                </template>

                <InputCheckbox name="terms" class="mt-4" v-if='!user.hasRole("zapo.employee")'>
                    <p class="text-grey-900 text-14 pl-2">
                        I agree to Zapo’s
                        <a href="https://www.zapo.com/privacy-policy" target="_blank" class="underline">Privacy Policy</a> and
                        <a href="https://www.zapo.com/terms-and-conditions" target="_blank" class="underline">Terms</a>
                    </p>
                </InputCheckbox>

                <input type='hidden' name='terms' value="1" v-else />

                <div class="pt-6">
                    <ButtonSaving class="button-black h-12 px-6" :disabled="saving"> Add new subscription </ButtonSaving>
                </div>
            </template>
        </template>
    </ModalFormCard>
</template>

<script>
import Subscription from '~/models/subscription.js'
import PaymentMethod from '~/models/payment-method.js'
import Modal from '~/mixins/modal.js'
import GoogleMap from '~/components/customer/blocks/google-map-old.vue'
import SubscriptionBreakdown from '~/components/customer/blocks/subscription-breakdown-inline.vue'

export default {
    mixins: [Modal],

    data() {
        return {
            action: '/subscription',
            value: {
                industry_id: null,
                plan_id: null,
                card_id: null,
                terms: null,
                product_id: 1,
                location_area_id: null
            },

            areas: [],
            plans: [],
            cards: [],
            waitingList: [],
            products: [
                {value: 1, html: 'Zapo Ads'}
            ]
        }
    },

    created() {
        this.value.industry_id = this.editingModel != null 
            ? this.editingModel.industry_id
            : this.user.loadSubscription().company.industry_id
        
        if (this.user.crm == null) {
            this.products.push({value: 2, html: 'Zapo CRM'})
        }

        if (this.options.value != null) {
            this.value = this.options.value
        }

        this.getLocations()
    },

    methods: {
        getLocations() {
            this.$axios
                .post('/actions/subscription-locations-for-trade', {
                    industry_id: this.value.industry_id,
                    product_id: this.value.product_id,
                    company_id: this.editingModel != null ? this.editingModel.id : this.user.loadSubscription().company.id
                })
                .then((res) => {
                    this.areas = res.areas
                    this.plans = res.plans
                    this.cards = PaymentMethod.fill(res.cards)

                    // this.cards.push({ html: 'Add new card', id: 'add' })

                    this.value.plan_id = this.plans.find((i) => i.name == 'Launch').id

                    this.waitingList = res.waiting_list

                    if (this.value.location_area_id == null) {
                        this.value.location_area_id = this.areas.find((i) => i.available == 1).id
                    }

                    if (this.options?.value != null) {
                        this.value.location_area_id = this.options.value.location_area_id
                    }

                    if (this.options.currentValue != null) {
                        this.value = this.options.currentValue
                    }

                    this.value.card_id = this.cards.find((i) => i.default_payment_method !== null).id
                })
        },

        toggleWaitingList(e) {
            this.$axios
                .post('/actions/join-waiting-list', {
                    location_area_id: this.value.location_area_id,
                    industry_id: this.value.industry_id,
                    product_id: 1,
                    company_id: this.editingModel != null ? this.editingModel.id : this.user.loadSubscription().company.id
                })
                .then((res) => {
                    this.waitingList = res.waiting_list
                    this.$event.$emit('modal-form-completed')
                })
        },
    },

    computed: {
        user() {
            return this.$authSanctum.getUser()
        },

        industries() {
            return this.options.industries.map((i) => {
                return {
                    value: i.id,
                    html: this.$help.capitalizeFirstLetter(i.name),
                }
            })
        },

        locations() {
            return this.areas.map((l) => {
                return {
                    value: l.id,
                    html: this.$help.capitalizeFirstLetter(l.name),
                }
            })
        },

        planOptions() {
            return this.plans.map((l) => {
                return {
                    value: l.id,
                    html: this.$help.capitalizeFirstLetter(l.name),
                }
            })
        },

        selected() {
            if (this.value.location_area_id == null || this.value.industry_id == null) {
                return false
            }

            return {
                plan: this.plans.find((i) => i.id == this.value.plan_id),
                area: this.areas.find((i) => i.id == this.value.location_area_id),
                industry: this.options.industries.find((i) => i.id == this.value.industry_id),
            }
        },

        isOnWaitingList() {
            return (
                this.waitingList.find((s) => {
                    return (
                        parseInt(s.location_area_id) == parseInt(this.value.location_area_id) &&
                        parseInt(s.industry_id) == parseInt(this.value.industry_id)
                    )
                }) != null
            )
        },
    },

    components: {
        GoogleMap,
        SubscriptionBreakdown,
    },
}
</script>
